import { http } from './http';

export async function login(username: string, password: string): Promise<string> {
  const res = await http.post('/auth/login', { username, password });
  return res.data.token as string;
}
